


































































































































import uuid from "uuid";
import { Prop, Component, Vue } from "vue-property-decorator";
import { formatShort } from "@/helpers/date-helper";
import { FolderEntry } from "@/models/file";
import ProjectManager from "../../entities/project-manager";
import ProjectWorker from "../../entities/project-worker";
import { ProjectMemberCardDecorator } from "@/decorators/project-member-card-decorator";
import ProjectMemberCard from "@/components/project/ProjectMemberCard.vue";

interface Tab {
  title: string;
  active: boolean;
  members: any;
}

@Component({
  components: {
    ProjectMemberCard
  }
})
export default class VFolderEntry extends Vue {
  @Prop({ required: true }) entry!: FolderEntry;
  @Prop({ default: true }) read?: boolean;
  @Prop({ default: 0 }) currenFolderId?: number;
  mouseover: Boolean = false;

  target = uuid();
  popoverShow = false;

  ePopHidden() {
    this.popoverShow = false;
    this.mouseover = false;
  }

  eMouseOverIn() {
    if (this.entry.kind === "folder") {
      return;
    } else {
      this.mouseover = true;
    }
  }

  eMouseOverOut() {
    if (this.entry.kind === "folder") {
      return;
    } else if (this.popoverShow === false) {
      this.mouseover = false;
    }
  }

  returnReadNum() {
    if (this.entry.readMembers) {
      return this.entry.readMembers.length;
    } else {
      return 0;
    }
  }

  get tabs(): Tab[] {
    return [
      {
        title: "管理者",
        active: true,
        members: this.tabManagers
      },
      {
        title: "作業者",
        active: false,
        members: this.tabWorkers
      }
    ];
  }

  get src() {
    if (!this.entry.image) {
      return "https://fakeimg.pl/75x100/";
    }
    return this.entry.image;
  }

  get alt() {
    return this.entry.name;
  }

  get lastModified(): string {
    return formatShort(this.entry.updated);
  }

  open() {
    this.$emit("open", this.entry);
  }

  movestart(e: DragEvent) {
    if (!e.dataTransfer) return;
    const d = e.dataTransfer;
    d.effectAllowed = "move";
    d.setData("id", String(this.entry.entryId));
  }

  move(e: DragEvent) {
    if (this.entry.kind !== "folder" && !this.entry.isEstimateTemplate) return;
    if (!e.dataTransfer) return;
    e.dataTransfer.dropEffect = "move";
    const id = e.dataTransfer.getData("id");
    if (!id) return;
    this.$emit("move", id, this.entry.entryId);
  }

  /* View Model */

  private get tabManagers() {
    return this.readManagers.map(ProjectMemberCardDecorator);
  }

  private get tabWorkers() {
    return this.readWorkers.map(ProjectMemberCardDecorator);
  }

  /* Model */

  private get readMemberIds(): number[] {
    return (this.entry.readMembers || []).map(m => m.projectMemberId);
  }

  private get readManagers() {
    return this.managers.filter(m =>
      this.readMemberIds.includes(m.projectMemberId)
    );
  }

  private get readWorkers() {
    return this.workers.filter(m =>
      this.readMemberIds.includes(m.projectMemberId)
    );
  }

  /* Store */

  private get managers(): ProjectManager[] {
    return this.$store.getters["member/assigned-managers"];
  }

  private get workers(): ProjectWorker[] {
    return this.$store.getters["member/assigned-workers"];
  }
}
